
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ProdottiClassiEditorDialog extends Serenity.Extensions.GridEditorDialog<ProdottiClassiRow> {
        protected getFormKey() { return ProdottiClassiForm.formKey; }
        protected getIdProperty() { return ProdottiClassiRow.idProperty; }
        protected getLocalTextPrefix() { return ProdottiClassiRow.localTextPrefix; }

        protected form = new ProdottiClassiForm(this.idPrefix);

        protected getToolbarButtons() {
            let buttons = super.getToolbarButtons();

            //Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);

            //
            if (Q.Authorization.hasPermission("Role:SuperAdmin")) {
                //Remove Button
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

                //Remove Button
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            }

            return buttons;
        }


        //protected afterLoadEntity() {
        //    super.afterLoadEntity();

        //    // Questa gestisce l'editor.
        //    this.form.AssetEsperienzeList.ambito = ProdottiClassiAssetEsperienze2Editor.AmbitoEnum.VisualizzaAssetEsperienze;
        //    this.form.AssetEsperienzeList.idProdottoClasse = this.entityId;
        //}
    }
}